import React from "react"
import PropTypes from "prop-types"

const ActivityFeedComment = props => {
  // Add safe checks for props with default values
  const firstname = props.Firstname || "Anonymous"
  const userComment = props.UserComment || "No comment"
  
  return (
    <>
      <div className="media py-2">
        <div className="avatar-xs me-3">
          <div className="avatar-title rounded-circle text-light">
            {firstname.charAt(0).toUpperCase()}
          </div>
        </div>
        <div className="media-body">
          {/* <h5 className="font-size-14 mb-1">
            {firstname}
            <small className="text-muted float-end">1 hr Ago</small>
          </h5> */}
          <p className="">
            {userComment}
          </p>
        </div>
      </div>
    </>
  )
}

ActivityFeedComment.propTypes = {
  Firstname: PropTypes.string,
  UserComment: PropTypes.string
}

// Add default props as a safety net
ActivityFeedComment.defaultProps = {
  Firstname: "Anonymous",
  UserComment: "No comment"
}

export default ActivityFeedComment